import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { ADMIN } from "@/constants/testIds";
import {
  LayoutDashboard, Package, FolderTree, ListOrdered, Gift, ClipboardList, BarChart3, MapPin, LogOut, Home, Ticket, Upload, Users, ShoppingCart, Settings, Menu, X
} from "lucide-react";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: ADMIN.navDashboard },
  { to: "/admin/orders", label: "Orders", icon: ClipboardList, testid: ADMIN.navOrders },
  { to: "/admin/carts", label: "Pending carts", icon: ShoppingCart, testid: "admin-nav-carts" },
  { to: "/admin/products", label: "Products", icon: Package, testid: ADMIN.navProducts },
  { to: "/admin/categories", label: "Categories", icon: FolderTree, testid: ADMIN.navCategories },
  { to: "/admin/category-strip", label: "Category Strip Management", icon: ListOrdered, testid: "admin-nav-category-strip" },
  { to: "/admin/combos", label: "Combos", icon: Gift, testid: ADMIN.navCombos },
  { to: "/admin/users", label: "Users", icon: Users, testid: ADMIN.navUsers },
  { to: "/admin/coupons", label: "Coupons", icon: Ticket, testid: ADMIN.navCoupons },
  { to: "/admin/bulk-upload", label: "Bulk upload", icon: Upload, testid: ADMIN.navBulkUpload },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3, testid: ADMIN.navAnalytics },
  { to: "/admin/restricted", label: "Available pincodes", icon: MapPin, testid: ADMIN.navRestricted },
  { to: "/admin/settings", label: "Settings", icon: Settings, testid: "admin-nav-settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div data-testid={ADMIN.layout} className="min-h-screen grid md:grid-cols-[240px_1fr]">
      <aside className="border-r border-hyd-border bg-hyd-panel/60 backdrop-blur">
        <div className="p-4 border-b border-hyd-border flex items-center justify-between">
          <Logo />
          <button
            type="button"
            aria-label={menuOpen ? "Close admin menu" : "Open admin menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
            className="md:hidden w-10 h-10 grid place-items-center rounded-lg text-hyd-text2 hover:bg-hyd-panel"
          >
            {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
        <nav className={`${menuOpen ? "block" : "hidden"} md:block p-3 space-y-1`}>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${
                  isActive ? "bg-hyd-gold/15 text-hyd-gold" : "text-hyd-text2 hover:bg-hyd-panel"
                }`
              }
            >
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className={`${menuOpen ? "block" : "hidden"} md:block p-3 mt-4 border-t border-hyd-border text-xs text-hyd-text3`}>
          <div className="mb-2">Signed in as <span className="text-hyd-gold">{user?.name}</span></div>
          <button onClick={() => navigate("/")} className="w-full flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-hyd-panel text-hyd-text2">
            <Home className="w-4 h-4" /> Storefront
          </button>
          <button onClick={() => { logout(); navigate("/"); }} className="w-full flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-hyd-panel text-hyd-red mt-1">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>
      <div className="min-w-0 w-full max-w-full p-3 sm:p-6">
        <Outlet />
      </div>
    </div>
  );
}
